import React from 'react'
import { Skeleton } from '@mui/material'

import { AppDataTable } from '@components'
import { useGroupedExportsModal } from 'Pages/ReportsAlerts/ExportsGrouping/@hooks'
import { reportNameColumn, officeDataColumn, exportUrlColumn } from 'Pages/ReportsAlerts/ExportsGrouping/Modal/Table/@columns'


export default function GroupingExportModalTable() {
	const { data, isLoading } = useGroupedExportsModal()

	if (isLoading) return <Skeleton variant="rectangular" height={600}/>

	return <AppDataTable title="Exported report data" data={data} columns={[ ...reportNameColumn(), ...officeDataColumn(), ...exportUrlColumn() ]}/>

}